import React, { useState, useEffect } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Password } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ICONS from "../assets";

const AdminSideBar = () => {
  const [open, setOpen] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showSidebar, setShowSidebar] = useState(false);
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const items = [
    {
      name: "Clothing Analytics",
      value: "/clothing-analytics",
      icon: <i className="bi bi-bar-chart"></i>,
      key: "clothinganalytics",
    },
    {
      name: "Box Break Analytics",
      value: "/box-break-analytics",
      icon: <i className="bi bi-bar-chart"></i>,
      key: "boxbreakanalytics",
    },
    {
      name: "Slider Images",
      value: "/home-page-slider",
      icon: <i class="bi bi-arrow-left-right"></i>,
      key: "slider",
    },
    {
      name: "Popup Content",
      value: "/popup-content",
      icon: <i class="bi bi-window-stack"></i>,
      key: "popupcontent",
    },
    // { name: "Categories", value: "/category", icon: <i className="bi bi-grid"></i>, key: "categories" },
    {
      name: "Categories",
      value: "/type",
      icon: <i className="bi bi-bag"></i>,
      key: "categories",
    },
    {
      name: "Brands",
      value: "/brands",
      icon: <i className="bi bi-box-seam"></i>,
      key: "brands",
    },
    {
      name: "Activity",
      value: "/activity",
      icon: <i class="bi bi-activity"></i>,
      key: "activity",
    },
    {
      name: "Model",
      value: "/model",
      icon: <i className="bi bi-slack"></i>,
      key: "model",
    },
    {
      name: "Materials",
      value: "/material",
      icon: <i className="bi bi-card-checklist"></i>,
      key: "materials",
    },
    {
      name: "Type",
      value: "/subtypes",
      icon: <i className="bi bi-list-task"></i>,
      key: "type",
    },
    {
      name: "Products",
      value: "/products",
      icon: <i className="bi bi-box"></i>,
      key: "products",
    },
    {
      name: "Cards",
      value: "/broken-cards",
      icon: <i className="bi bi-credit-card-2-front"></i>,
      key: "brokencards",
    },
    {
      name: "Categories & Teams",
      value: "/broken-card-category",
      icon: <i className="bi bi-people-fill"></i>,
      key: "cardscategories",
    },
    {
      name: "Shipment Requests",
      value: "/box-requests",
      icon: <i className="bi bi-credit-card-2-front"></i>,
      key: "boxrequests",
    },
    {
      name: "Box Break Orders",
      value: "/box-break-orders",
      icon: <i className="bi bi-receipt"></i>,
      key: "boxbreakorders",
    },
    {
      name: "Vault",
      value: "/box-break-vault",
      icon: <i className="bi bi-credit-card-2-front"></i>,
      key: "boxvault",
    },
    {
      name: "Restore",
      value: "/store-products",
      icon: <i class="bi bi-arrow-clockwise"></i>,
      key: "restore",
    },
    {
      name: "Seller Auctions",
      value: "/seller-auctions",
      icon: <i className="bi bi-hammer"></i>,
      key: "sellerauctions",
    },
    {
      name: "Buyer Bids",
      value: "/buyer-bids",
      icon: <i className="bi bi-cash-coin"></i>,
      key: "buyerbids",
    },

    {
      name: "Seasons",
      value: "/seasons",
      icon: <i className="bi bi-cloud-drizzle"></i>,
      key: "seasons",
    },
    {
      name: "Gender",
      value: "/gender",
      icon: <i className="bi bi-people"></i>,
      key: "gender",
    },
    {
      name: "Color",
      value: "/color",
      icon: <i className="bi bi-paint-bucket"></i>,
      key: "color",
    },
    {
      name: "Size Category",
      value: "/sizecategory",
      icon: <i class="bi bi-ui-checks-grid"></i>,
      key: "sizecategory",
    },
    ,
    {
      name: "Region",
      value: "/region",
      icon: <i class="bi bi-geo-alt-fill"></i>,
      key: "region",
    },
    {
      name: "Sizes",
      value: "/size",
      icon: <i className="bi bi-arrows-move"></i>,
      key: "sizes",
    },
    {
      name: "Restore Size",
      value: "/restore-size",
      icon: <i class="bi bi-arrow-clockwise"></i>,
      key: "restoresize",
    },

    {
      name: "Store Management",
      value: "/store",
      icon: <i class="bi bi-person-gear"></i>,
      key: "role",
    },
    {
      name: "Users",
      value: "/users",
      icon: <i className="bi bi-person"></i>,
      key: "users",
    },
    {
      name: "Seller",
      value: "/seller",
      icon: <i className="bi bi-person"></i>,
      key: "seller",
    },
    {
      name: "Buyer",
      value: "/buyer",
      icon: <i className="bi bi-person"></i>,
      key: "buyer",
    },
    {
      name: "Country",
      value: "/country",
      icon: <i className="bi bi-geo-alt"></i>,
      key: "country",
    },
    {
      name: "Subscribers",
      value: "/subscribers",
      icon: <i className="bi bi-envelope-paper"></i>,
      key: "subscribers",
    },
    {
      name: "Blogs",
      value: "/blogdetail",
      icon: <i className="bi bi-card-text"></i>,
      key: "Blogs",
    },
    {
      name: "Withdraw Amount",
      value: "/wallet",
      icon: <i className="bi bi-wallet-fill"></i>,
      key: "Wallet",
    },

    {
      name: "Coupon",
      value: "/coupon",
      icon: <i class="bi bi-ticket-perforated"></i>,
      key: "coupon",
    },
    {
      name: "Offers",
      value: "/offers",
      icon: <i className="bi bi-percent"></i>,
      key: "offers",
    },

    // { name: "Auctions", value: "/item-listing", icon: <i className="bi bi-hammer"></i>, key: "auctions" },
    {
      name: "Orders",
      value: "/orders",
      icon: <i className="bi bi-bag-check"></i>,
      key: "orders",
    },
    {
      name: "Payments",
      value: "/payments",
      icon: <i className="bi bi-credit-card"></i>,
      key: "payments",
    },
    {
      name: "Requests",
      value: "/requests",
      icon: <i className="bi bi-plus-circle"></i>,
      key: "requests",
    },
    {
      name: "Selling Ask",
      value: "/seller-ask",
      icon: <i class="bi bi-card-checklist"></i>,
      key: "sellerask",
    },
    {
      name: "Seller Bulk Ask",
      value: "/seller-bulk-ask",
      icon: <i class="bi bi-upload"></i>,
      key: "sellerbulkask",
    },
    {
      name: "Buying Bids",
      value: "/buyer-bid",
      icon: <i class="bi bi-bag-fill"></i>,
      key: "buyerbid",
    },
    {
      name: "Audit Logs",
      value: "/audit-logs",
      icon: <i className="bi bi-journal-text"></i>,
      key: "auditlogs",
    },
    {
      name: "Grading",
      value: "/grading",
      icon: <i class="bi bi-trophy"></i>,
      key: "grading",
    },
  ];

  const menuGroups = [
    {
      title: "Dashboard",
      icon: <i className="bi bi-speedometer2"></i>,
      keys: ["clothinganalytics", "boxbreakanalytics"],
    },
    {
      title: "HomePage ",
      icon: <i class="bi bi-collection"></i>,
      keys: ["slider", "popupcontent"],
    },
    {
      title: "Product Setup",
      icon: <i className="bi bi-box-seam"></i>,
      keys: [, "products", "restore", "sellerauctions", "buyerbids"],
    },
    {
      title: "Box Break",
      icon: <i className="bi bi-box-seam"></i>,
      keys: [
        "brokencards",
        "cardscategories",
        "boxrequests",
        "boxbreakorders",
        "boxvault",
        "grading",
      ],
    },
    {
      title: "Attributes",
      icon: <i className="bi bi-sliders"></i>,
      keys: [
        "seasons",
        "gender",
        "categories",
        "brands",
        "model",
        "materials",
        "type",
      ],
    },
    {
      title: "Sizes",
      icon: <i className="bi bi-arrows-move"></i>,
      keys: ["region", "sizecategory", "sizes", "restoresize"],
    },
    {
      title: "Blogs",
      icon: <i className="bi bi-card-text"></i>,
      keys: ["Blogs"],
    },
    {
      title: "Coupons and Offers",
      icon: <i class="bi bi-ticket-perforated"></i>,
      keys: ["coupon","offers"],
    },
    // {
    //   title: "Offers",
    //   icon: <i className="bi bi-percent"></i>,
    //   keys: ["offers"],
    // },
    {
      title: "Commerce",
      icon: <i className="bi bi-cart-check"></i>,
      keys: [
        "orders",
        "payments",
        "Wallet",
        "requests",
        "sellerask",
        "sellerbulkask",
        "buyerbid",
      ],
    },
    {
      title: "Users & Access",
      icon: <i className="bi bi-people"></i>,
      keys: ["role", "seller", "buyer", "subscribers"],
    },
    {
      title: "Audit",
      icon: <i className="bi bi-shield-check"></i>,
      keys: ["auditlogs"],
    },
  ];

  const managmentMenuGroup = [
    {
      title: "Dashboard",
      icon: <i className="bi bi-speedometer2"></i>,
      keys: ["clothinganalytics", "boxbreakanalytics"],
    },
    {
      title: "HomePage ",
      icon: <i class="bi bi-collection"></i>,
      keys: ["slider","popupcontent"],
    },
    {
      title: "Product Setup",
      icon: <i className="bi bi-box-seam"></i>,
      keys: [, "products", "restore", "sellerauctions", "buyerbids"],
    },
    {
      title: "Box Break",
      icon: <i className="bi bi-box-seam"></i>,
      keys: ["brokencards", "cardscategories", "boxrequests", "boxbreakorders", "boxvault"],
    },
    {
      title: "Attributes",
      icon: <i className="bi bi-sliders"></i>,
      keys: [
        "seasons",
        "gender",
        "categories",
        "brands",
        "model",
        "materials",
        "type",
      ],
    },
    {
      title: "Sizes",
      icon: <i className="bi bi-arrows-move"></i>,
      keys: ["region", "sizecategory", "sizes"],
    },
    {
      title: "Commerce",
      icon: <i className="bi bi-cart-check"></i>,
      keys: ["orders", "payments", "Blogs", "Wallet", "requests"],
    },
    {
      title: "Users & Access",
      icon: <i className="bi bi-people"></i>,
      keys: ["seller", "buyer"],
    },
  ];

  const getItemsByKeys = (keys) => items.filter((i) => keys?.includes(i?.key));

  return (
    <>
      {/* Mobile Toggle */}
      {isMobile && (
        <button
          className="btn btn-light"
          onClick={() => setShowSidebar(true)}
          style={{ position: "fixed", top: 10, left: 10, zIndex: 1101 }}
        >
          <MenuIcon />
        </button>
      )}

      {/* Overlay */}
      {isMobile && showSidebar && (
        <div
          onClick={() => setShowSidebar(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.4)",
            zIndex: 1100,
          }}
        />
      )}

      {/* Sidebar */}
      <div
        style={{
          position: isMobile ? "fixed" : "sticky",
          top: 0,
          height: "100vh",
          width: 260,
          background: "#fff",
          zIndex: 1101,
          transform: isMobile
            ? showSidebar
              ? "translateX(0)"
              : "translateX(-100%)"
            : "translateX(0)",
          transition: "transform 0.3s ease",
        }}
      >
        {/* Logo */}
        <div className="d-flex justify-content-center align-items-center p-0">
          <Link to="/">
            <img
              src={ICONS.STOX_LOGO}
              alt="logo"
              className="img-fluid m-auto"
              style={{
                height: "98px",
                paddingTop: "9px",
                paddingBottom: "10px",
              }}
            />
          </Link>
          {isMobile && (
            <button
              className="btn btn-close me-2 border position-absolute top-0 end-0 m-3 border-0"
              onClick={() => setShowSidebar(false)}
            ></button>
          )}
        </div>

        <Sidebar className="p-0">
          <Menu>
            {user?.role == "store-manager"
              ? managmentMenuGroup?.map((group) => (
                  <SubMenu
                    className=" fs-6 fw-bold text-black"
                    key={group.title}
                    label={group.title}
                    icon={group.icon}
                  >
                    {getItemsByKeys(group.keys).map((item) => (
                      <MenuItem
                        key={item.key}
                        className={
                          item.value === location.pathname ? "is-active" : ""
                        }
                        component={<Link to={item.value} />}
                        onClick={() => isMobile && setShowSidebar(false)}
                      >
                        {item.icon} {item.name}
                      </MenuItem>
                    ))}
                  </SubMenu>
                ))
              : menuGroups?.map((group) => (
                  <SubMenu
                    className=" fs-6 fw-bold text-black"
                    key={group.title}
                    label={group.title}
                    icon={group.icon}
                  >
                    {getItemsByKeys(group.keys).map((item) => (
                      <MenuItem
                        key={item.key}
                        className={
                          item.value === location.pathname ? "is-active" : ""
                        }
                        component={<Link to={item.value} />}
                        onClick={() => isMobile && setShowSidebar(false)}
                      >
                        {item.icon} {item.name}
                      </MenuItem>
                    ))}
                  </SubMenu>
                ))}

            {user?.role === "staff" && (
              <MenuItem
                component={<Link to="/change-password" />}
                className={
                  location.pathname === "/change-password" ? "is-active" : ""
                }
              >
                <Password /> Change Password
              </MenuItem>
            )}
          </Menu>
        </Sidebar>
      </div>
    </>
  );
};

export default AdminSideBar;
